import React from "react";
import { useParams } from "react-router-dom";
import AppBarMenu from "../../components/AppBarMenu";
import Container from "@mui/material/Container";
import EditProject from "../../components/management/project/edit";

/**
 * Página dedicada para editar um projeto
 * URL: /projects/:id
 * Aceita tanto projectNumber (7 dígitos) quanto projectId (< 6 dígitos)
 */
export default function ProjectEditPage() {
  const { id } = useParams();

  // Detectar se é projectNumber (7 dígitos) ou projectId (< 6 dígitos)
  const isProjectNumber = id && id.length >= 6;

  return (
    <AppBarMenu>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <EditProject
          initialProjectId={isProjectNumber ? null : parseInt(id)}
          initialProjectNumber={isProjectNumber ? id : null}
          onProjectNumberSearch={() => {}}
          onProjectIdLoad={() => {}}
          onClearProject={() => {}}
        />
      </Container>
    </AppBarMenu>
  );
}
